<template>
  <div class="x-tablelist-view quota-records">
    <div class="search-warp">
      <el-input
        v-model="filter.name"
        clearable
        class="record-name-filter"
        :placeholder="$t('HT.subordinate.quota.accountPlaceholder')"
      ></el-input>
      <!-- <el-select v-model="filter.type" clearable placeholder="操作类型" class="record-select">
        <el-option
          v-for="item in operationTypes"
          :key="item.value || 'all'"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-date-picker
        v-model="filter.date"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        class="record-date"
      ></el-date-picker> -->
      <el-button type="primary" size="small" @click="search">{{ $t('HT.search') }}</el-button>
      <el-button plain size="small" @click="reset">{{ $t('HT.reset') }}</el-button>
    </div>
    <div class="x-table-box">
      <ux-table
        ref="table"
        :showPage="true"
        :hide-on-single-page="true"
        maxHeight="100%"
        :data="tableData.list"
        :columns="columns"
        :total="tableData.totalSize"
        :size.sync="filter.size"
        :page.sync="filter.page"
        @changePage="changePage"
        @changeSize="changeSize"
        :emptyText="$t('HT.nodata')"
        layout="total, sizes, prev, pager, next"
      ></ux-table>
    </div>
  </div>
</template>

<script lang="jsx">
// 接口配额单位为次，页面展示单位为万次
const QUOTA_UNIT = 10000;

export default {
  name: 'QuotaRecords',
  data() {
    return {
      // 分配记录筛选参数
      filter: { name: '', type: '', date: [], page: 1, size: 10 },
      // 配额操作类型筛选项
      operationTypes: [
        { label: this.$t('HT.subordinate.quota.allOperations'), value: '' },
        { label: this.$t('HT.subordinate.quota.allocate'), value: 'ALLOCATE' },
        { label: this.$t('HT.subordinate.quota.revoke'), value: 'WITHDRAW' },
        { label: this.$t('HT.subordinate.quota.adjust'), value: 'ADJUST' }
      ],
      // 当前页配额操作记录
      records: [],
      // 配额操作记录总数
      totalSize: 0
    };
  },
  computed: {
    // ux-table 服务端分页数据和总数
    tableData() {
      return {
        totalSize: this.totalSize,
        list: this.records
      };
    },
    columns() {
      return [
        {
          label: this.$t('HT.subordinate.quota.operationTime'),
          prop: 'operation_time',
          width: 170
        },
        {
          label: this.$t('HT.subordinate.quota.operationType'),
          width: 100,
          render: (h, row) =>
            h(
              'el-tag',
              { props: { size: 'mini', type: this.getRecordType(row.operation_type) } },
              [this.getOperationTypeText(row.operation_type)]
            )
        },
        {
          label: this.$t('HT.subordinate.quota.accountName'),
          minWidth: 180,
          align: 'left',
          prop: 'account_name'
        },
        {
          label: this.$t('HT.subordinate.common.level'),
          prop: 'account_type',
          width: 80,
          formatter: (row, column, cellValue) => this.getAccountTypeText(cellValue)
        },
        {
          label: this.$t('HT.subordinate.quota.quotaBefore'),
          width: 150,
          align: 'right',
          prop: 'quota_before',
          formatter: (row, column, cellValue) => this.formatQuota(cellValue)
        },
        {
          label: this.$t('HT.subordinate.quota.changeAmount'),
          width: 135,
          align: 'right',
          render: (h, row) =>
            h(
              'span',
              { class: row.change_amount >= 0 ? 'increase' : 'decrease' },
              `${row.change_amount >= 0 ? '+' : ''}${this.formatQuota(row.change_amount)}`
            )
        },
        {
          label: this.$t('HT.subordinate.quota.quotaAfter'),
          width: 150,
          align: 'right',
          prop: 'quota_after',
          formatter: (row, column, cellValue) => this.formatQuota(cellValue)
        },
        {
          label: this.$t('HT.subordinate.quota.operator'),
          prop: 'operator_name',
          width: 125,
          align: 'left'
        },
        {
          label: this.$t('HT.subordinate.common.remark'),
          prop: 'remark',
          minWidth: 180,
          tooltip: true,
          align: 'left'
        }
      ];
    }
  },
  created() {
    this.getRecords();
  },
  methods: {
    // 获取配额分配记录分页列表
    getRecords() {
      const date = this.filter.date || [];
      const params = {
        accountname: this.filter.name.trim(),
        operation_type: this.filter.type,
        start_time: date[0] ? `${date[0]} 00:00:00` : '',
        end_time: date[1] ? `${date[1]} 23:59:59` : '',
        page: this.filter.page,
        size: this.filter.size
      };
      this.$uxLoading.show();
      this.$api.accountQuota.getRecords(params).then((res) => {
        if (res.code == 10000) {
          this.records = res.data || [];
          this.totalSize = res.total_size || 0;
        }
      });
    },
    // 格式化配额数值
    formatQuota(value) {
      return (Number(value || 0) / QUOTA_UNIT).toFixed(2);
    },
    // 将操作类型转换为中文
    getOperationTypeText(type) {
      const typeMap = {
        ALLOCATE: this.$t('HT.subordinate.quota.allocate'),
        WITHDRAW: this.$t('HT.subordinate.quota.revoke'),
        RECLAIM: this.$t('HT.subordinate.quota.reclaim'),
        ADJUST: this.$t('HT.subordinate.quota.adjust')
      };
      return typeMap[type] || type;
    },
    // 将账号类型转换为页面层级
    getAccountTypeText(type) {
      const typeMap = {
        SUPERVISOR: this.$t('HT.subordinate.common.levelOne'),
        OWNER: this.$t('HT.subordinate.common.levelTwo'),
        SUBSIDIARY: this.$t('HT.subordinate.common.levelThree')
      };
      return typeMap[type] || type;
    },
    getRecordType(type) {
      return type === 'WITHDRAW' ? 'danger' : type === 'ADJUST' ? 'warning' : 'success';
    },
    // 触发分配记录查询
    search() {
      this.filter.page = 1;
      this.getRecords();
    },
    reset() {
      this.filter = { name: '', type: '', date: [], page: 1, size: this.filter.size };
      this.getRecords();
    },
    changePage(page) {
      this.filter.page = page;
      this.getRecords();
    },
    changeSize(size) {
      this.filter.size = size;
      this.filter.page = 1;
      this.getRecords();
    },
  }
};
</script>

<style lang="scss" scoped>

.search-warp {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 18px;
  .record-name-filter {
    width: 220px;
  }
  .record-select {
    width: 140px;
  }
  .record-date {
    width: 270px;
  }
  .export-button {
    margin-left: auto;
  }
}.increase {
  color: #21b779;
}
.decrease {
  color: #f56c6c;
}
</style>
